import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { ShipmentModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  public create(entrySummaryId: number, shipment: Partial<ShipmentModel>, isShowLoader?: boolean): Observable<ShipmentModel> {
    return this.apiService.post<ShipmentModel>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/entry-summaries/${entrySummaryId}/shipments`,
      shipment,
      null,
      { isShowLoader },
    );
  }

  public update(shipmentId: number, shipment: Partial<ShipmentModel>): Observable<ShipmentModel> {
    return this.apiService.put<ShipmentModel>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/shipments/${shipmentId}`,
      shipment,
    );
  }

  public delete(shipmentId: number): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/customs-broker/shipments/${shipmentId}`);
  }
}
